import React from 'react';

export type MarketRealm = 'crypto' | 'ashare' | 'macro' | 'backtest' | 'system';

export interface RealmOption {
  id: MarketRealm;
  label: string;
  sub: string;
  icon: string;
  defaultRoute: string;
}

export const REALM_OPTIONS: RealmOption[] = [
  {
    id: 'crypto',
    label: '加密货币',
    sub: 'Crypto 24/7',
    icon: '🪙',
    defaultRoute: '#/regime',
  },
  {
    id: 'ashare',
    label: '中国A股',
    sub: 'A-Share 5000+',
    icon: '🇨🇳',
    defaultRoute: '#/ashare/screener',
  },
  {
    id: 'macro',
    label: '宏观大宗',
    sub: 'Global Macro',
    icon: '🌐',
    defaultRoute: '#/macro',
  },
  {
    id: 'backtest',
    label: '回测中枢',
    sub: 'Backtest Hub',
    icon: '🧪',
    defaultRoute: '#/backtest/crypto',
  },
  {
    id: 'system',
    label: '系统治理',
    sub: 'Infra & Gateway',
    icon: '🛡️',
    defaultRoute: '#/gateway',
  },
];

export interface MarketRealmSwitcherProps {
  currentRealm: MarketRealm;
  onSelectRealm: (realm: MarketRealm) => void;
}

export const MarketRealmSwitcher: React.FC<MarketRealmSwitcherProps> = ({
  currentRealm,
  onSelectRealm,
}) => {
  return (
    <div
      className="market-realm-switcher"
      role="tablist"
      aria-label="资产市场域选择器"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        background: 'var(--bg-surface-elevated)',
        border: '1px solid var(--border-subtle)',
        borderRadius: '8px',
        padding: '2px',
        gap: '2px',
      }}
    >
      {REALM_OPTIONS.map((opt) => {
        const isActive = currentRealm === opt.id;
        return (
          <button
            key={opt.id}
            role="tab"
            aria-selected={isActive}
            id={`realm-tab-${opt.id}`}
            onClick={() => onSelectRealm(opt.id)}
            className={`realm-tab-btn ${isActive ? 'active' : ''}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 10px',
              borderRadius: '6px',
              border: 'none',
              background: isActive ? 'var(--color-cyan)' : 'transparent',
              color: isActive ? 'var(--text-inverse)' : 'var(--text-secondary)',
              fontWeight: isActive ? 600 : 500,
              fontSize: '12px',
              cursor: 'pointer',
              transition: 'all 0.15s ease',
            }}
            title={`${opt.label} (${opt.sub})`}
          >
            <span style={{ fontSize: '14px' }}>{opt.icon}</span>
            <span>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};
